var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcPipExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6247",
    fill: "none",
    d: "M0 0h25v25H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11372",
    stroke: "#fff",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 94",
    d: "M14.434 19.743H3.266V3.711h16.118v10.023",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 6248",
    fill: "#fff",
    strokeLinejoin: "round",
    d: "M21.692 21.028h-9.037v-8.023h9.037z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1043",
    fill: "none",
    strokeWidth: 1.5,
    d: "M10.564 10.976L6.183 6.787"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26745",
    d: "M6.182 10.864V6.786h4.033",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
export default SvgIcPipExit;